//  Immediately Invoked Function Expression to keep the javascript Scope contained
(function() {
    angular
        .module('app')
        .directive('fileModel', fileModel);

    fileModel.$inject = ['$parse'];

    // This directive makes the model of the file marked for upload accessible
    function fileModel($parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;

                element.bind('change', function(){
                    scope.$apply(function(){
                        modelSetter(scope, element[0].files[0]);

                        scope.$emit('fileModelChanged', {});
                    });
                });
            }
        };
    }
})();

//  Immediately Invoked Function Expression to keep the javascript Scope contained
(function() {
    angular
        .module('app')
        .directive("ngUploadChange",function(){
    return{
        scope:{
            ngUploadChange:"&"
        },
        link:function($scope, $element, $attrs){
            $element.on("change",function(event){
                $scope.$apply(function(){
                    $scope.ngUploadChange({$event: event})
                })
            })
            $scope.$on("$destroy",function(){
                $element.off();
            });
        }
    }
});
})();